function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-373.642 -318.344)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M583.658 328.849H419.626c-19.6 0-35.488 15.888-35.488 35.487v164.015c0 19.599 15.888 35.486 35.488 35.486h164.032c19.6 0 35.488-15.888 35.488-35.486V364.337c0-19.599-15.889-35.488-35.488-35.488z",
  fill: "red"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: -1854.896,
  y1: 1320.426,
  x2: -1906.593,
  y2: 1169.736,
  gradientTransform: "rotate(180 -326.61 537.647) scale(.5915)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M557.056 338.895H446.227c-29.337 0-52.955 23.81-52.955 53.385v108.127c.95 23.086 4.603 8.491 11.555-17.075 8.081-29.713 34.396-55.682 66.445-75.145 24.461-14.855 51.84-24.341 101.68-25.244 28.264-.511 25.77-36.683-15.896-44.048z",
  opacity: 0.554,
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M436.972 371.548c14.795-13.239 32.142-22.554 58.673-17.738v85.281c-1.137 4.093-4.548 5.003-7.504 2.729l-51.169-70.272zM542.859 402.589c11.886 7.424 25.188 22.263 28.957 44.116l-57.133 9.25c-3.295-1.253-5.773-3.321-5.457-8.187l33.633-45.179zM516.39 475.74c-3.686.828-5.635 3.043-4.776 7.505l28.897 48.918c12.85-5.896 25.676-19.658 31.48-40.049L516.39 475.74zM486.712 482.562c3.822-.495 7.392-.569 8.528 3.411l1.706 54.58c-18.774 1.389-34.43-3.458-45.028-18.421l34.794-39.57zM479.207 457.319c2.73 3.281 4.262 6.733.683 10.916l-52.533 18.421c-6.193-17.1-5.626-33.159 0-48.439l51.85 19.102z",
  fill: "#fff"
}));

function SvgYelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "10.496 10.505 235.008 234.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYelpIcon);
export default __webpack_public_path__ + "static/media/yelp-icon.f6614d6b.svg";
export { ForwardRef as ReactComponent };